import { default as localeCustomizations } from './locales'
import { default as containerCustomizations } from './customizations'
import { IPartnerConfig } from '../../internal'

import logo from './assets/Honeywell-Logo-PNG-Transparent.png';

// must export all of these for each partner. Empty if using defaults
const partnerCustomizations: IPartnerConfig = {
  assets: {
    logoOnBackground: logo,
    logoOnSecondary: logo,
    logoOnPrimary: logo,
    logoOnDark: logo
  },
  locales: localeCustomizations,
  containers: containerCustomizations,
}
export default partnerCustomizations;